import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import ServicesPage from '@/pages/services/page';
import FleetPage from '@/pages/fleet/page';
import ReferencesPage from '@/pages/references/page';
import ContactPage from '@/pages/contact/page';
import SssPage from '@/pages/sss/page';
import NotFound from '@/pages/NotFound';
import GirisPage from '@/pages/giris/page';
import UyeOlPage from '@/pages/uye-ol/page';
import EkspresKuryePage from '@/pages/services/ekspres-kurye/page';
import ETicaretPage from '@/pages/services/e-ticaret/page';
import KargoTasimaciligiPage from '@/pages/services/kargo-tasimaciligi/page';
import FulfillmentPage from '@/pages/services/fulfillment/page';
import OnlineMagazaPage from '@/pages/services/online-magaza/page';
import MikroIhracatPage from '@/pages/services/mikro-ihracat/page';
import AtrBelgesiPage from '@/pages/services/atr-belgesi/page';
import OnBoardKuryePage from '@/pages/services/on-board-kurye/page';
import SigortaPage from '@/pages/services/sigorta/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/hakkimizda', element: <AboutPage /> },
  { path: '/hizmetler', element: <ServicesPage /> },
  { path: '/hizmetler/ekspres-kurye-servisi', element: <EkspresKuryePage /> },
  { path: '/hizmetler/uluslararasi-e-ticaret-servisi', element: <ETicaretPage /> },
  { path: '/hizmetler/uluslararasi-kargo-tasimaciligi', element: <KargoTasimaciligiPage /> },
  { path: '/hizmetler/fulfillment', element: <FulfillmentPage /> },
  { path: '/hizmetler/online-magaza', element: <OnlineMagazaPage /> },
  { path: '/hizmetler/mikro-ihracat-etgb', element: <MikroIhracatPage /> },
  { path: '/hizmetler/atr-belgesi', element: <AtrBelgesiPage /> },
  { path: '/hizmetler/on-board-kurye-servisi', element: <OnBoardKuryePage /> },
  { path: '/hizmetler/sigorta', element: <SigortaPage /> },
  { path: '/filo-ve-teknoloji', element: <FleetPage /> },
  { path: '/referanslar', element: <ReferencesPage /> },
  { path: '/sss', element: <SssPage /> },
  { path: '/iletisim', element: <ContactPage /> },
  { path: '/giris', element: <GirisPage /> },
  { path: '/uye-ol', element: <UyeOlPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
